<template>
  <el-container class="home-container">
    <!-- 顶部导航栏 -->
    <el-header height="60px" class="header">
      <div class="header-left">
        <el-button 
          type="primary" 
          plain 
          @click="toggleSidebar" 
          class="sidebar-toggle"
          size="small"
        >
          <el-icon><Menu /></el-icon>
        </el-button>
        <span class="logo">人工影响天气平台-AI版</span>
      </div>
      <div class="header-right">
        <div class="header-actions">
          <el-button type="text" class="header-btn" size="small">
            <el-icon><Bell /></el-icon>
          </el-button>
          <el-button type="text" class="header-btn" size="small">
            <el-icon><Setting /></el-icon>
          </el-button>
        </div>
        <el-dropdown>
          <div class="user-info">
            <el-avatar size="small" :src="userAvatar"></el-avatar>
            <span class="user-name">{{ userName }}</span>
            <el-icon class="el-icon--right"><ArrowDown /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <el-icon><User /></el-icon>
                <span>个人中心</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-icon><Setting /></el-icon>
                <span>设置</span>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <el-icon><SwitchButton /></el-icon>
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    
    <el-container>
      <!-- 左侧菜单栏 -->
      <el-aside :width="sidebarWidth" class="sidebar" :class="{ 'sidebar-collapsed': collapsed }">
        <el-menu
          default-active="map"
          class="el-menu-vertical-demo"
          background-color="#1f2937"
          text-color="rgba(255, 255, 255, 0.85)"
          active-text-color="#3b82f6"
          :collapse="collapsed"
          :collapse-transition="false"
          :router="true"
        >
          <el-menu-item index="map">
            <el-icon><House /></el-icon>
            <template #title>首页</template>
          </el-menu-item>
          <el-menu-item index="warning">
            <el-icon><Warning /></el-icon>
            <template #title>监测预警</template>
          </el-menu-item>
          <el-menu-item index="analysis">
            <el-icon><DataAnalysis /></el-icon>
            <template #title>作业条件分析</template>
          </el-menu-item>
          <el-menu-item index="4">
            <el-icon><Document /></el-icon>
            <template #title>作业方案设计</template>
          </el-menu-item>
          <el-menu-item index="5">
            <el-icon><Operation /></el-icon>
            <template #title>作业指挥调度</template>
          </el-menu-item>
          <el-menu-item index="6">
            <el-icon><TrendCharts /></el-icon>
            <template #title>效果评估</template>
          </el-menu-item>
          <el-menu-item index="7">
            <el-icon><Goods /></el-icon>
            <template #title>产品管理</template>
          </el-menu-item>
          <el-menu-item index="8">
            <el-icon><Message /></el-icon>
            <template #title>信息管理</template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
     
      <el-main class="main-content">
     
          <router-view style="width: 100%; height: 100%;"/>
    
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, computed } from 'vue';
import { 
  Menu, 
  ArrowDown, 
  House, 
  Document, 
  Warning, 
  DataAnalysis, 
  Operation, 
  TrendCharts, 
  Goods, 
  Message,
  Bell,
  User,
  SwitchButton,
  Setting
} from '@element-plus/icons-vue';

const collapsed = ref(false);
const sidebarWidth = computed(() => collapsed.value ? '64px' : '200px');
const userName = ref('管理员');
const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png');

const toggleSidebar = () => {
  collapsed.value = !collapsed.value;
};
</script>

<style scoped>
.home-container {
  height: 100vh;
  overflow: hidden;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.header {
  background-color: #111827;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sidebar-toggle {
  font-size: 16px;
  color: #e5e7eb;
  border-color: rgba(255, 255, 255, 0.2);
  transition: all 0.3s;
}

.sidebar-toggle:hover {
  border-color: #e5e7eb;
  background-color: rgba(255, 255, 255, 0.1);
}

.logo {
  font-size: 18px;
  font-weight: 600;
  color: #f3f4f6;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-btn {
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.3s;
}

.header-btn:hover {
  color: #f3f4f6;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-name {
  font-size: 14px;
  color: #f3f4f6;
}

.sidebar {
  background-color: #1f2937;
  transition: width 0.3s;
  overflow: hidden;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.sidebar-collapsed {
  width: 64px !important;
}

/* 自定义菜单样式 */
:deep(.el-menu-vertical-demo) {
  border-right: none;
  padding: 12px 0;
}

:deep(.el-menu-item) {
  height: 56px;
  line-height: 56px;
  margin: 0 8px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.3s;
}

:deep(.el-menu-item:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

:deep(.el-menu-item.is-active) {
  background-color: rgba(59, 130, 246, 0.2) !important;
}

.main-content {
  padding: 0;
  background-color: #1865b1;
  /* overflow-y: auto; */
  /* background-color: red; */
  width: calc(100% - 200px);
  height: 100%;
}

.content-wrapper {
  padding: 24px;
  min-height: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 0 16px;
  }
  
  .logo {
    font-size: 16px;
  }
  
  .sidebar {
    position: fixed;
    left: 0;
    top: 60px;
    height: calc(100vh - 60px);
    z-index: 100;
  }
  
  .content-wrapper {
    padding: 16px;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>